/**
 * The deliberately-in-water placeholder coordinates the enrichment pipeline assigns to jobs with
 * no derivable location at all (remote/hybrid/anywhere and no company address) — see
 * `UNKNOWN_LOCATION_SEA_FALLBACK_GEOLOC` in `lambda/utils/mapboxGeocodeFallbackForEnrichedJob.ts`.
 * Duplicated here (a test asserts the two stay in sync) because web-app client code must not
 * import from `lambda/` (ESM/CJS interop breaks outside vitest).
 */
export const SEA_FALLBACK_GEOLOC = { lat: 59.75, lng: 24.95 };

/** Coordinate-equality slack: the fallback is written verbatim, so anything this close IS it. */
const EPSILON = 1e-6;

export function isSeaFallbackGeoloc(point: { lat: number; lng: number } | null | undefined): boolean {
  if (!point) return false;
  return (
    Math.abs(point.lat - SEA_FALLBACK_GEOLOC.lat) < EPSILON &&
    Math.abs(point.lng - SEA_FALLBACK_GEOLOC.lng) < EPSILON
  );
}
